import React from 'react'; 
import { useEffect, useState } from "react";
import { Dialog, DialogContent, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { RootState, useAppDispatch, useAppSelector } from "../../../state/state";
import { closeModal } from "../../../state/ModalSlice/ModalSlice";
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import { selectEffectiveUID } from '../../../state/UserStatesV2/userSliceV2.ts';
export default function WhatsappUnblockNotification() {
    const open = useAppSelector((state: RootState) => state.ModalSlice.WhatsappUnblockNotificationOpen);
    const providerId = useAppSelector(selectEffectiveUID) 
    const [optinUrl, setOptinUrl] = useState<string>("https://wa.me/message/PPRTZCMJ6GEED1");
    const Dispatch = useAppDispatch();

    useEffect(() => {
        const fetchOptinUrl = async () => {
            if (providerId) {
                const db = getFirestore();
                const q = query(collection(db, 'CustomBranding'), where('providerReference', '==', providerId));
                const querySnapshot = await getDocs(q);
                
                if (!querySnapshot.empty) {
                    const doc = querySnapshot.docs[0];
                    const data = doc.data();
                    setOptinUrl(data.optinUrl || "https://wa.me/message/PPRTZCMJ6GEED1");
                }
            }
        };

        fetchOptinUrl();
    }, [providerId]);

    function handleClose() {
        Dispatch(closeModal("WhatsappUnblockNotificationOpen"))
    }

    return (
        <React.Fragment>
            <Dialog
                sx={{
                    padding: 0,
                    '& .MuiPaper-root': {
                        borderRadius: '10px',
                    },
                }}
                maxWidth="md"
                open={open}
                PaperProps={{
                    component: 'div',

                }}
            >
                <DialogContent sx={{paddingX: "60px", paddingY: "50px"}} className={"bg-white"}>
                    <div className={"header pb-[20px]"}>
                        <p className={"text-cf_heading font-[600] "}>Unblock Whatsapp</p>
                    </div>
                    <div className={"absolute right-4 top-4"}><IconButton onClick={handleClose}>
                        <CloseIcon/>
                    </IconButton></div>
                    <div className={""}>
                        <div className={""}>
                            <div className={"flex w-full"}>
                                <div className={"w-[550px]"}>
                                    <Box
                                        component={"div"}
                                        sx={{}}
                                    >
                                        <p>A shareable link has been copied to your clipboard. Please share it with your
                                            customer to unblock WhatsApp notifications in case they have blocked
                                            them.</p>
                                        <p className={"mt-2"}> You can also manually copy it from here <span className={"underline-offset-2 underline text-cc_link"}>{optinUrl}</span></p>
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"flex gap-2 pt-8 justify-center"}>
                        <button onClick={(e) => {
                            e.preventDefault();
                            handleClose()
                        }}
                                className={"w-[100%] bg-cc_bg-tertiary border border-solid border-gray-500 p-1.5 rounded-lg"}>Close
                        </button>
                    </div>
                </DialogContent>

            </Dialog>

        </React.Fragment>
    );
}